import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { TokenOverviewApi } from '@backend/api/stores/TokenOverviewStore'
import { apiFetch, FormError } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<TokenOverviewApi>('/api/stores/tokenOverview', { fetch: apiFetch })

export const viewModeAtom = atom<'type' | 'layer'>('type')
export const selectedThemeIdAtom = atom('')

export const refreshAtom = atomWithQuery((get) => {
  const themeId = get(selectedThemeIdAtom)
  return {
    queryKey: ['TokenOverviewStore', themeId],
    queryFn: async () => {
      const query: Record<string, string> = {}
      if (themeId) query.themeId = themeId
      const res = await api.refresh.$get({ query })
      return await res.json()
    },
  }
})

export const createThemeAtom = atom(null, async (get, set, data: { name: string; description?: string }) => {
  if (!data.name.trim()) throw new FormError('请输入主题名称')
  await api.createTheme.$post({ json: { name: data.name.trim(), description: data.description } })
  await get(refreshAtom).refetch()
})

export function loader(store: Store) {
  store.set(viewModeAtom, 'type')
  store.set(selectedThemeIdAtom, '')
  store.get(refreshAtom)
  return null
}
